<form [formGroup]="form" (ngSubmit)="save()" novalidate>
  <div class="modal-header">
    <h2 class="modal-title" id="ks-prefill-modal-title">{{ title() }}</h2>

    <button type="button" class="ks-modal-close" aria-label="Cerrar" (click)="cancel()">
      <i class="bi bi-x-lg" aria-hidden="true"></i>
    </button>
  </div>

  <div class="modal-body">
    <div class="ks-form-group">
      <label class="ks-label" for="ks-prefill-template">Plantilla</label>

      @if (isEdit()) {
        <input
          id="ks-prefill-template"
          type="text"
          class="ks-field"
          [value]="templateName()"
          readonly
          aria-describedby="ks-prefill-template-hint" />

        <p class="ks-field-hint" id="ks-prefill-template-hint">
          La plantilla no se puede cambiar: los valores ya capturados pertenecen a sus campos.
        </p>
      } @else {
        <!--
          ng-select, no <select>: todos los desplegables de la consola deben
          permitir BUSCAR. El id del input interno lo pone `labelForId`, asi
          que el `<label for>` de arriba sigue apuntando al elemento que
          recibe el foco. `aria-describedby` senala SIEMPRE al mismo id: la
          pista y el error son excluyentes en la plantilla, asi que solo uno
          existe a la vez.
        -->
        <ng-select
          labelForId="ks-prefill-template"
          formControlName="templateId"
          [items]="templateOptions()"
          bindLabel="label"
          bindValue="templateId"
          placeholder="Selecciona una plantilla"
          notFoundText="Sin resultados"
          clearAllText="Quitar selección"
          loadingText="Cargando…"
          typeToSearchText="Escribe para buscar"
          [searchable]="true"
          [inputAttrs]="templateInputAttrs()"
          [class.is-invalid]="invalid('templateId')" />

        @if (invalid('templateId')) {
          <p class="ks-field-error" id="ks-prefill-template-error" role="alert">
            <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
            Elige la plantilla del prerellenado.
          </p>
        } @else {
          <p class="ks-field-hint" id="ks-prefill-template-hint">
            Solo se listan las plantillas activas. No se podrá cambiar después.
          </p>
        }
      }
    </div>

    <div class="ks-form-group">
      <label class="ks-label" for="ks-prefill-name">Nombre</label>

      <input
        id="ks-prefill-name"
        type="text"
        class="ks-field"
        formControlName="name"
        autocomplete="off"
        placeholder="Netflix"
        [attr.aria-invalid]="invalid('name') ? 'true' : null"
        [attr.aria-describedby]="invalid('name') ? 'ks-prefill-name-error' : null" />

      @if (invalid('name')) {
        <p class="ks-field-error" id="ks-prefill-name-error" role="alert">
          <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
          Escribe un nombre de máximo 150 caracteres.
        </p>
      }
    </div>

    <div class="ks-form-group">
      <span class="ks-label">Imagen</span>

      <div class="ks-upload">
        <span class="ks-upload__preview" aria-hidden="true">
          @if (preview()) {
            <img [src]="preview()" alt="" />
          } @else if (file()) {
            <i class="bi bi-file-earmark-pdf"></i>
          } @else if (currentImage()) {
            <img [src]="currentImage()" alt="" />
          } @else {
            <i class="bi bi-image"></i>
          }
        </span>

        <div class="ks-upload__body">
          <input
            id="ks-prefill-file"
            type="file"
            class="ks-upload__input"
            [accept]="accept"
            aria-describedby="ks-prefill-file-hint"
            (change)="onFileChange($event)" />

          <label class="ks-btn ks-btn--glass ks-btn--sm" for="ks-prefill-file">
            <i class="bi bi-upload" aria-hidden="true"></i>
            {{ currentImage() || file() ? 'Cambiar archivo' : 'Elegir archivo' }}
          </label>

          @if (file()) {
            <p class="ks-upload__name">
              {{ file()!.name }}
              <button
                type="button"
                class="ks-icon-btn ks-icon-btn--danger ks-upload__clear"
                aria-label="Quitar el archivo seleccionado"
                (click)="clearFile()">
                <i class="bi bi-x-lg" aria-hidden="true"></i>
              </button>
            </p>
          }

          @if (fileError()) {
            <p class="ks-field-error" role="alert">
              <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
              {{ fileError() }}
            </p>
          } @else {
            <p class="ks-field-hint" id="ks-prefill-file-hint">
              JPG, PNG o PDF, hasta 5 MB. Se sube al guardar.
            </p>
          }
        </div>
      </div>
    </div>

    @if (isEdit()) {
      <fieldset class="ks-switches">
        <legend class="ks-label">Opciones</legend>

        <label class="ks-switch ks-switch--row" for="ks-prefill-status">
          <input
            id="ks-prefill-status"
            type="checkbox"
            role="switch"
            class="ks-switch__input"
            formControlName="status"
            aria-describedby="ks-prefill-status-hint" />

          <span class="ks-switch__track" aria-hidden="true">
            <span class="ks-switch__thumb"></span>
          </span>

          <span class="ks-switch__text">
            <span class="ks-switch__title">Activo</span>
            <span class="ks-switch__hint" id="ks-prefill-status-hint">
              Solo los prerellenados activos se ofrecen en la app.
            </span>
          </span>
        </label>
      </fieldset>
    }
  </div>

  <div class="modal-footer">
    <button type="button" class="ks-btn ks-btn--glass" (click)="cancel()">Cancelar</button>
    <button type="submit" class="ks-btn ks-btn--primary">
      <i class="bi bi-check-lg" aria-hidden="true"></i>
      Guardar
    </button>
  </div>
</form>
